import * as React from "react";
import {
  DataGrid,
  GridCellParams,
  GridColDef,
  GridSortModel,
  GridValueFormatterParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import "./styles.scss";
import { convertToLocal } from "../../utils/dateFormat";
import { TransactionDetailsType } from "../../types/genericType";
import "./styles.scss";
import { currencyFormatter } from "../../utils/utils";

const getRows = (transactionDetails: Array<TransactionDetailsType>) => {
  const rows: {
    id: number;
    client: string;
    account: number;
    accountName: string;
    fromClientId: string;
    type: string;
    date: Date;
    amount: number;
    balance: number;
    status: string;
    description: string;
    checkNumber: number | null;
  }[] = [];
  transactionDetails?.forEach((transaction: TransactionDetailsType) => {
    if (transaction) {
      rows.push({
        id: transaction?.id,
        client: transaction?.client,
        account: transaction?.account,
        accountName: transaction?.accountName,
        fromClientId: transaction?.fromClientId,
        type: transaction?.code,
        date: new Date(transaction?.date),
        checkNumber: transaction?.checkNumber,
        amount: transaction?.amount,
        balance: transaction?.balance,
        status: transaction?.status,
        description: transaction?.description,
      });
    }
  });
  return rows;
};

type TransactionTableProps = {
  transactionData: Array<TransactionDetailsType>;
};

const TransactionTable = (props: TransactionTableProps) => {
  const transactionDetails = props?.transactionData;
  const [sortModel, setSortModel] = React.useState<GridSortModel>([
    { field: "date", sort: "desc" },
  ]);

  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
  };

  const columns: GridColDef[] = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "date",
        headerName: "Date",
        minWidth: 120,
        valueFormatter: (params: GridValueFormatterParams) =>
          convertToLocal(params.value).format("MM/DD/YYYY"),
        headerClassName: "header-datagrid",
      },
      {
        field: "account",
        headerName: "Acct. #",
        width: 150,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "accountName",
        headerName: "Acct. Name",
        minWidth: 150,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "description",
        headerName: "Description",
        width: 150,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "type",
        headerName: "Type",
        width: 120,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "amount",
        headerName: "Amount",
        type: "number",
        minWidth: 160,
        sortComparator: (a: string, b: string) =>
          Number(a.slice(1)) - Number(b.slice(1)),
        valueGetter: (params: GridValueGetterParams) =>
          `${params.row.amount > 0 ? "+" : "-"}${currencyFormatter.format(
            Math.abs(params.row.amount)
          )}`,
        headerClassName: "header-datagrid",
        cellClassName: (params: GridCellParams<any, any>) =>
          params.row.amount >= 0 ? "positive-cell" : "negative-cell",
      },
      {
        field: "balance",
        headerName: "Balance",
        type: "number",
        minWidth: 160,
        valueGetter: (params: GridValueGetterParams) =>
          `$ ${params.row.balance.toFixed(2) || ""}`,
        headerClassName: "header-datagrid",
      },
    ],
    []
  );

  return (
    <>
      <DataGrid
        rows={getRows(transactionDetails)}
        getRowId={(row) => row.id}
        columns={columns}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 30, 40, 50]}
        rowSelection={false}
        className="datagrid"
        disableRowSelectionOnClick
      />
    </>
  );
};

export default TransactionTable;
